const {bind} = require('./lib/bind')
const {Get} = require('./lib/ajax')

bind(document, 'DOMContentLoaded', function() {
  document.querySelectorAll('.slide-viewability-toggle').forEach((el) => {
    bind(el, 'click', function(e) {

      this.toggleRequest = new Get(el.dataset.uri, {
        success: function(response) {
          el.closest('.card').classList.remove('viewable', 'not-viewable')
          el.closest('.card').classList.add(response.class)
        },
        error: function(response) { console.log('error', response) }
      })
    })
  });
});

// Toggle slide image edit form
bind(document, 'DOMContentLoaded', function() {
  document.querySelectorAll('.slide-replace-form-toggle').forEach((el) => {
    bind(el, 'click', function(e) {
      el.closest('.slide-edit').querySelector('.replace-slide-form').toggleAttribute('hidden')
    })
  });
});

// Update slide image preview
bind(document, 'DOMContentLoaded', function() {
  document.querySelectorAll('.replace_slide').forEach((el) => {
    el.addEventListener("ajax:success", function(event) {
      const [_data, status, xhr] = event.detail
      const data = JSON.parse(_data)
      if(typeof data.image.preview.url !== 'undefined') {
        el.closest('.slide-edit').querySelector('.slide-image').style.backgroundImage = `url(${data.image.preview.url})`
        el.setAttribute('hidden', true)
      }
      const alert = el.closest('.slide-edit').querySelector('.alert-info');
      alert.textContent = "Slide updated"
      alert.classList.add('visible')

      setTimeout(() => {
        alert.classList.remove('visible');
      }, 3000)

    });

    el.addEventListener("ajax:error", function(event) {
      const [_data, status, xhr] = event.detail
      const alert = el.closest('.slide-edit').querySelector('.alert-danger')
      alert.textContent = "Error!"
      alert.classList.add('visible')

      setTimeout(() => {
        alert.classList.remove('visible');
      }, 3000)
    });

  });
});

// Update slide notes
bind(document, 'DOMContentLoaded', function() {
  document.querySelectorAll('.edit_slide').forEach((el) => {

    el.addEventListener("ajax:success", function(event) {
      const [_data, status, xhr] = event.detail
      const data = JSON.parse(_data)

      const alert = el.closest('.slide-edit').querySelector('.alert-info')
      alert.classList.add('visible')

      setTimeout(() => {
        alert.classList.remove('visible')
      }, 3000)
    })

    el.addEventListener("ajax:error", function(xhr, status, error) {
      console.log('error', data, status, xhr)
      const alert = el.closest('.slide-edit').querySelector('.alert-danger')
      alert.classList.add('visible')
      setTimeout(() => {
        alert.classList.remove('visible')
      }, 3000)
    });

  });
});
